import React, { useState } from "react";

import { getFarmIdFromLocalStorage, useGetFarms, useTranslation, useUserContext } from "utils";

import { Col, Drawer, Flex, IconButton, Row, Spin } from "components";

import { FarmDetails } from "pages/app/farm/components/FarmDetails";
import HomePageFarmListCard from "pages/app/home/components/HomePageFarmCard";

export const HomePageFarmList = () => {
  const { t } = useTranslation(["dashboard", "onboarding"]);
  const { data: farms, refetch: refetchFarms, isLoading } = useGetFarms();
  const { switchFarm, reloadUserData } = useUserContext();
  const currentFarmId = getFarmIdFromLocalStorage();
  const [showAddFarmDrawer, setShowAddFarmDrawer] = useState(false);

  const handleFarmSelect = (farmId: string) => {
    switchFarm(farmId);
    reloadUserData();
  };

  const handleFarmAdded = () => {
    setShowAddFarmDrawer(false);
    refetchFarms();
  };

  return (
    <div className="home-page-farm-list">
      <Flex justify="space-between" align="center" className="farm-list-header">
        <h2 className="farm-list-title">{t("dashboard:farmCard.title")}</h2>
        <IconButton
          onClick={() => setShowAddFarmDrawer(true)}
          iconName="klim/plus"
          size="small"
          type="tertiary"
          tooltip={{ title: t("dashboard:farmCard.addFarm") }}
        />
      </Flex>
      <Row className="farm-list-row">
        {/* prelint-ignore-col */}
        {isLoading ? (
          <Flex align="center" justify="center" style={{ height: "100px", width: "100%" }}>
            <Spin />
          </Flex>
        ) : farms ? (
          farms.map((farm, i) => (
            <Col key={farm.id} xs={24} sm={24} md={12} className={`farm-list-col ${i % 2 === 0 ? "even" : "odd"}`}>
              <HomePageFarmListCard farm={farm} onFarmUpdated={refetchFarms} isCurrentFarm={farm.id === currentFarmId} onFarmSelect={handleFarmSelect} />
            </Col>
          ))
        ) : (
          <Col xs={24}>{t("dashboard:farmsList.nofarm")}</Col>
        )}
      </Row>
      <Drawer title={t("onboarding:onboardingFormHeader.farm")} onClose={() => setShowAddFarmDrawer(false)} visible={showAddFarmDrawer}>
        <FarmDetails isOnboarding={false} handleBack={() => setShowAddFarmDrawer(false)} selectedFarmId="" onFinish={handleFarmAdded} />
      </Drawer>
    </div>
  );
};

export default HomePageFarmList;
